export default __webpack_public_path__ + "7a58ed449da8297ecc893c3cc987c3b1.png";